class Cart extends HTMLElement {
    connectedCallback() {
        this.Cart = this;
        this.isCartPage = document.body.classList.contains('template-cart');
        this.cartPackageProductId = this.getAttribute('data-cart-package-variant-id');
    }

    updateCart(response) {
        document.body.classList.add('cart-is-updating');

        this.getSectionsToRender().forEach((section => {
            document.querySelector(section.selector).innerHTML = this.getSectionInnerHTML(response.sections[section.id], section.selector);
        }));

        document.body.classList.remove('cart-is-updating');
        window.lozadObserver.observe();
    }
  
    getSectionsToRender() {
        if (this.isCartPage) {
            return [
                {
                    id: 'main-cart', // match liquid file name main-cart.liquid
                    selector: '.main-cart'
                },
                {
                    id: 'cart-icon-bubble', // match liquid file name cart-icon-bubble.liquid
                    selector: '#cart-icon-bubble'
                }
            ];
        } else {
            return [
                {
                    id: 'drawer-cart', // match liquid file name drawer-cart.liquid
                    selector: 'w3-drawer-cart .drawer__main'
                },
                {
                    id: 'drawer-cart', // match liquid file name drawer-cart.liquid
                    selector: 'w3-drawer-cart .drawer__footer'
                },
                {
                    id: 'cart-icon-bubble', // match liquid file name cart-icon-bubble.liquid
                    selector: '#cart-icon-bubble'
                }
            ];
        }
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    displayErrorMessage(error) {
        this.cartError = this.querySelector('.js-cart-error-message');
        if (this.cartError && error) {
            this.cartError.classList.add('visible');
            this.cartError.querySelector('.js-cart-error-text').innerHTML = error;
        }
    }

    checkHipliEligibility() {
        // Parse the JSON data from the <script> tag
        const cartJsonScript = this.Cart.querySelector('#cart-json');
        const cartData = JSON.parse(cartJsonScript.textContent);

        if (!cartData) { return; }
      
        // Find the cart package product ID and set it as an excluded ID
        const hipli_product_id = parseInt(this.cartPackageProductId);

        // Count the number of items in the cart (excluding the cart package)
        const itemCount = cartData.items.reduce((total, item) => {
            if (item.product_id !== hipli_product_id) {
                return total + item.quantity;
            }
            return total;
        }, 0);
      
        // Check eligibility for each type
        let eligibleTypes = [];
        const eligibilityCriteria = {
          "Rigide": {
            types: ["Mugs", "Bouteilles One"],
            variantNames: ["300ml", "500ml"]
          },
          "Hiplus": {
            types: ["Bouteilles Originals", "Bouteilles Active", "Bouteilles Kids"],
            variantNames: ["350ml", "500ml", "600ml"]
          },
          "Magnus": {
            types: ["Bouteilles Active", "Bouteilles Titan", "Bouteilles Originals"],
            variantNames: ["750ml", "1L.", "1,5L"]
          }
        };

        for (const type in eligibilityCriteria) {
            const { types, variantNames } = eligibilityCriteria[type];
            const isEligible =
            (type === "Magnus" && (itemCount === 1 || itemCount === 2) && cartData.items.every(item => item.product_id === hipli_product_id || (types.includes(item.product_type) && variantNames.includes(item.variant_title) && !item.variant_title.includes("custom")))) ||
            (type !== "Magnus" && itemCount === 1 && cartData.items.every(item => item.product_id === hipli_product_id || (types.includes(item.product_type) && variantNames.includes(item.variant_title) && !item.variant_title.includes("custom"))));
            if (isEligible) {
                eligibleTypes.push(type);
            }
        }

        // Return the eligibility status and the eligible types
        return {
          isEligible: eligibleTypes.length > 0,
          eligibleTypes: eligibleTypes
        };
    }
}

customElements.define('w3-cart', Cart);


class CartItems extends HTMLElement {
    updateQuantity(line, quantity) {
        this.Cart = document.querySelector('w3-cart');
        document.body.classList.add('cart-is-updating');

        const body = JSON.stringify({
            line,
            quantity,
            sections: this.Cart.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => response.json())
            .then((response) => {
                if (response.errors) {
                    this.Cart.displayErrorMessage(response.errors)
                    document.body.classList.remove('cart-is-updating');
                    return;
                }
                this.Cart.updateCart(response)
            })
            .finally(() => {
                document.body.classList.remove('cart-is-updating');
                window.lozadObserver.observe();
            }).catch((e) => {
                console.error(e);
                document.body.classList.add('cart-is-updating');
            });
    }
}
  
customElements.define('w3-cart-items', CartItems);

class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const cartItems = this.closest('w3-cart-items');
            cartItems.updateQuantity(this.dataset.index, 0);
        });
    }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartUpdateQuantity extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const quantity = parseInt(this.dataset.currentQuantity) + parseInt(this.dataset.targetQuantity);
            const cartItems = this.closest('w3-cart-items');
            cartItems.updateQuantity(this.dataset.index, quantity);
        });
    }
}

customElements.define('cart-update-quantity-button', CartUpdateQuantity);

class CartPackageItem extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.CartPackageItem = this;

        this.Cart = document.querySelector('w3-cart');
        const eligibility = this.Cart.checkHipliEligibility();

        if (!eligibility.isEligible) {
            const cartItems = this.closest('w3-cart-items');
            cartItems.updateQuantity(this.dataset.index, 0);
        }
    }
}

customElements.define('cart-package-item', CartPackageItem);

class CartShippingButton extends HTMLElement {
    constructor() {
        super();

        this.cartShippingButton = this;
        this.cartShipping = document.querySelector('.js-cart-shipping');

        if(this.cartShippingButton && this.cartShipping) {
            this.cartShippingButton.addEventListener('click', () => {
                this.cartShipping.classList.toggle('active');
            })
        }
    }
}

customElements.define('cart-shipping-button', CartShippingButton);

class CartPackageCheckbox extends HTMLElement {
    constructor() {
        super();

        this.CartPackageCheckbox = this;
        this.Cart = document.querySelector('w3-cart');

        this.cartPackageAttribute = this.Cart.querySelector('#cart-package-attribute');

        this.hipliEligibility = this.Cart.checkHipliEligibility();

        const hipliType = this.hipliEligibility.eligibleTypes[0];
        this.packageVariantId = this.CartPackageCheckbox.querySelector(`[data-hipli-type="${hipliType}"]`)       

        if (this.hipliEligibility.isEligible && this.packageVariantId) {
            this.initPackageAddToCart();
        } else {
            this.CartPackageCheckbox.style.display = 'none';
        }
    }

    initPackageAddToCart() {
        this.checkbox = this.querySelector('.js-cart-add-package-checkbox');
        this.checkbox.addEventListener('change', e => {
            if(e.target.checked === true) {
                this.packageVariantId.disabled = false;
                const packageAddButton = this.querySelector('#product-package-add-to-cart');
                packageAddButton.click();
            }
        });
    }
}

customElements.define('cart-package-checkbox', CartPackageCheckbox);

class CartFreeProductItem extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.CartFreeProductItem = this;
        const isNoLongerEligible = this.CartFreeProductItem.hasAttribute('no-longer-eligible');

        if (isNoLongerEligible) {
            const cartItems = this.closest('w3-cart-items');
            cartItems.updateQuantity(this.dataset.index, 0);
        }
    }
}

customElements.define('cart-free-item', CartFreeProductItem);
